import React, { Suspense, useCallback, useRef } from 'react';
import { Canvas } from '@react-three/fiber';

import useTriggerStore from '../../../../common/store/useTriggerStore';
import StaticApples from './StaticApples';
import FallApples from './FallApples';
import SwirlApples from './SwirlApples';
import useSwirlAnimation from './useSwirlAnimation';

const Scene = () => {

  const appleFall = useTriggerStore(useCallback(state => state.appleFall, []));

  const group = useRef<THREE.Group>(null);

  useSwirlAnimation(group);

  return (
    <>
      <group ref={group}>
        <FallApples />
        <SwirlApples />
      </group>

      {!appleFall && <StaticApples />}
    </>
  );
}

const WebGL = () => (
  <Canvas style={{
    position: "absolute",
    zIndex: 0,
    top: "0",
    left: "0",
    height: "100vh",
    width: "100vw"
  }}>
    <ambientLight intensity={0.7} />

    <Suspense fallback={null}>
      <Scene />
    </Suspense>
  </Canvas>
);

export default React.memo(WebGL);